/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type { Registre } from '@/types';

import validationInformationsActe from '../validationInformationsActe';
import validationInformationsEvenementReconnaissance from '../validationInformationsEvenementReconnaissance';

/**
 * Validation de l'étape « Acte » pour la reconnaissance : informations de
 * l'acte (réutilisées telles quelles) + informations sur l'évènement (bloc
 * spécifique reconnaissance). L'état civil de l'enfant est validé séparément
 * par `validationStepEnfantReconnaissance`, dans sa propre étape.
 *
 * Aucune collision de clés entre les 2 blocs (`registre`/`sousTypeActe`/
 * `dateActe`/… vs `auteurReconnaissance`/`dateReconnaissance`/…).
 */
const validationStep1Reconnaissance = (
  data: Record<string, any>,
  selectedRegistre?: Partial<Registre>,
) => ({
  ...validationInformationsActe(data, selectedRegistre),
  ...validationInformationsEvenementReconnaissance(data),
});

export default validationStep1Reconnaissance;
